/* UOVO theme — small interactive bits */
(function () {
  'use strict';

  // ---- Drawers (mobile menu + search + cart) ----
  const drawers = {
    menu: {
      el: document.querySelector('[data-menu-drawer]'),
      trigger: document.querySelector('[data-menu-toggle]'),
      focus: () => {
        const link = drawers.menu.el && drawers.menu.el.querySelector('a, button');
        if (link) link.focus();
      },
    },
    search: {
      el: document.querySelector('[data-search-drawer]'),
      trigger: document.querySelector('[data-search-toggle]'),
      focus: () => {
        const input = drawers.search.el && drawers.search.el.querySelector('[data-search-input]');
        if (input) {
          // small delay so the transform finishes before focusing
          setTimeout(() => input.focus(), 50);
        }
      },
    },
    // button[...]: the overlay <div> also carries data-drawer-close and comes first.
    cart: {
      el: document.querySelector('[data-cart-drawer]'),
      trigger: document.querySelector('[data-cart-toggle]'),
      focus: () => {
        const btn = drawers.cart.el && drawers.cart.el.querySelector('button[data-drawer-close]');
        if (btn) setTimeout(() => btn.focus(), 50);
      },
    },
    sizeChart: {
      el: document.querySelector('[data-size-chart-drawer]'),
      // Multiple triggers (desktop legend + mobile size sheet) — handled via
      // delegated listener below instead of the manager's single-trigger path.
      trigger: null,
      focus: () => {
        const btn = drawers.sizeChart.el && drawers.sizeChart.el.querySelector('button[data-drawer-close]');
        if (btn) setTimeout(() => btn.focus(), 50);
      },
    },
  };

  let openDrawer = null;

  function closeDrawer() {
    if (!openDrawer) return;
    const d = drawers[openDrawer];
    if (d.el) {
      d.el.classList.remove('is-open');
      d.el.setAttribute('aria-hidden', 'true');
      // wait for transition before hiding to keep animation smooth
      setTimeout(() => {
        if (!d.el.classList.contains('is-open')) d.el.setAttribute('hidden', '');
      }, 280);
    }
    if (d.trigger) d.trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-drawer-open');
    openDrawer = null;
  }

  function openDrawerByName(name) {
    if (openDrawer && openDrawer !== name) closeDrawer();
    const d = drawers[name];
    if (!d || !d.el) return;
    d.el.removeAttribute('hidden');
    // force reflow so the transform transitions
    void d.el.offsetWidth;
    d.el.classList.add('is-open');
    d.el.setAttribute('aria-hidden', 'false');
    if (d.trigger) d.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-drawer-open');
    openDrawer = name;
    if (typeof d.focus === 'function') d.focus();
  }

  Object.keys(drawers).forEach((name) => {
    const d = drawers[name];
    if (!d.el || !d.trigger) return;
    d.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (openDrawer === name) {
        closeDrawer();
      } else {
        openDrawerByName(name);
      }
    });
  });

  // Delegated close — works for elements that get re-rendered (e.g. inside cart drawer).
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });

  // Delegated open for size chart drawer — handles multiple triggers
  // (the size-fieldset legend button + the mobile size-sheet button).
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-size-chart-toggle]')) return;
    e.preventDefault();
    if (openDrawer === 'sizeChart') closeDrawer();
    else if (drawers.sizeChart.el) openDrawerByName('sizeChart');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openDrawer) closeDrawer();
  });

  // ---- Cart drawer: AJAX add / quantity / remove ----
  const cartDrawerEl = drawers.cart.el;
  const headerCountEl = document.querySelector('[data-cart-count]');

  function refreshCartDrawerFromSection(sectionHtml) {
    if (!cartDrawerEl || !sectionHtml) return;
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer] .drawer__panel');
    const current = cartDrawerEl.querySelector('.drawer__panel');
    if (fresh && current) current.innerHTML = fresh.innerHTML;

    // Sync header cart count badge.
    const freshCount = doc.querySelector('[data-cart-drawer-count]');
    const count = freshCount ? parseInt(freshCount.textContent.trim(), 10) || 0 : 0;
    if (headerCountEl) {
      headerCountEl.textContent = count;
      if (count > 0) headerCountEl.removeAttribute('hidden');
      else headerCountEl.setAttribute('hidden', '');
    }
  }

  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('Cart request failed: ' + res.status);
    return res.json();
  }

  async function ajaxAddToCart(form) {
    const formData = new FormData(form);
    const items = [{
      id: parseInt(formData.get('id'), 10),
      quantity: parseInt(formData.get('quantity') || '1', 10),
    }];
    const data = await postJSON('/cart/add.js', { items, sections: 'cart-drawer' });
    if (data.sections && data.sections['cart-drawer']) {
      refreshCartDrawerFromSection(data.sections['cart-drawer']);
    }
    openDrawerByName('cart');
  }

  async function ajaxChangeLine(lineKey, quantity) {
    const data = await postJSON('/cart/change.js', { id: lineKey, quantity, sections: 'cart-drawer' });
    if (data.sections && data.sections['cart-drawer']) {
      refreshCartDrawerFromSection(data.sections['cart-drawer']);
    }
  }

  // Intercept PDP product form submit -> AJAX add -> open drawer.
  const productForm = document.querySelector('#product-form');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const submit = productForm.querySelector('[data-add-to-cart]');
      // needs-size covers submits that don't come from clicking the button
      // (Enter in the form), which the click handler wouldn't catch.
      if (submit && (submit.disabled || submit.dataset.needsSize === 'true')) return;
      ajaxAddToCart(productForm).catch((err) => {
        console.error(err);
        // Fall back to a regular form submit so the user isn't stuck.
        productForm.submit();
      });
    });
  }

  // Delegated handlers for drawer quantity changes and remove clicks
  // (markup gets swapped on every refresh, so listen on document).
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-drawer-qty]');
    if (!input) return;
    const key = input.dataset.lineKey;
    const qty = Math.max(0, parseInt(input.value, 10) || 0);
    ajaxChangeLine(key, qty).catch((err) => console.error(err));
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-drawer-remove]');
    if (!btn) return;
    e.preventDefault();
    ajaxChangeLine(btn.dataset.lineKey, 0).catch((err) => console.error(err));
  });

  // ---- Sticky header scroll shadow ----
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const isOverlay = header.classList.contains('site-header--overlay');
    const announcementEl = document.querySelector('.announcement-bar');

    const measureAnnouncement = () => {
      const h = announcementEl ? announcementEl.offsetHeight : 0;
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        h + 'px'
      );
      return h;
    };

    const measureHeader = () => {
      // Only expose the header height when it overlays content so the next
      // section can grow to keep its visible area unchanged.
      const h = isOverlay ? header.offsetHeight : 0;
      document.documentElement.style.setProperty(
        '--header-overlay-height',
        h + 'px'
      );
      return h;
    };

    // Height of the header while it is pinned (sticky, or the overlay header
    // once it turns fixed), for html { scroll-padding-top } in theme.css.
    // Without overflow clip (iOS 15 and older) the sticky header scrolls away.
    const headerSection = header.closest('.shopify-section');
    const measurePinnedHeader = () => {
      const pinned = isOverlay || (
        headerSection &&
        getComputedStyle(headerSection).position === 'sticky' &&
        CSS.supports('overflow-x', 'clip')
      );
      document.documentElement.style.setProperty(
        '--site-header-height',
        (pinned ? header.offsetHeight : 0) + 'px'
      );
    };

    let announcementHeight = measureAnnouncement();
    measureHeader();
    measurePinnedHeader();

    const onScroll = () => {
      // In overlay mode, lock to the viewport once the announcement bar has
      // fully scrolled out — at that moment the absolute header is already
      // at viewport y=0, so position: absolute -> fixed has no visual jump.
      const scrolled = isOverlay
        ? window.scrollY >= announcementHeight
        : window.scrollY > 4;
      header.classList.toggle('is-scrolled', scrolled);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => {
        measureHeader();
        measurePinnedHeader();
      }).observe(header);
    }

    if (announcementEl && 'ResizeObserver' in window) {
      new ResizeObserver(() => {
        announcementHeight = measureAnnouncement();
        onScroll();
      }).observe(announcementEl);
    }
  }

  // ---- Desktop nav dropdowns ----
  // Disclosure pattern for menu items with child links (sections/header.liquid).
  // The label link always navigates; the chevron button toggles the panel.
  // Mouse: opens on hover (short delay against flicker) and closes shortly
  // after the pointer leaves. A click on the chevron always toggles: it pins a
  // closed or hover-opened panel open only when it lands within
  // HOVER_CLICK_GRACE of the hover opening it (that click was already on its
  // way to open the panel, so it must not snap it shut); any later click
  // closes it. Touch: hover is ignored, so tapping the chevron toggles and
  // tapping the label navigates. Keyboard: Enter/Space or ArrowDown on the
  // chevron, Escape closes and returns focus to the chevron, tabbing out
  // closes. Outside click, opening another item and dropping below the
  // desktop breakpoint close it too. Items are (re)bound on load and after a
  // theme-editor section reload. No-op when no item has children.
  const HOVER_OPEN_DELAY = 120;
  const HOVER_CLOSE_DELAY = 250;
  const HOVER_CLICK_GRACE = 200;
  const navDesktopQuery = window.matchMedia('(min-width: 990px)');
  let openNavItem = null;

  const navParts = (item) => ({
    toggle: item.querySelector('[data-nav-dropdown-toggle]'),
    panel: item.querySelector('[data-nav-dropdown-panel]'),
  });

  const closeNavDropdown = (item, returnFocus) => {
    const { toggle, panel } = navParts(item);
    clearTimeout(item._navTimer);
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
    delete item.dataset.openedBy;
    if (openNavItem === item) openNavItem = null;
    if (returnFocus) toggle.focus({ preventScroll: true });
  };

  const openNavDropdown = (item, openedBy) => {
    if (openNavItem && openNavItem !== item) closeNavDropdown(openNavItem);
    const { toggle, panel } = navParts(item);
    clearTimeout(item._navTimer);
    // Let the panel's top padding reach the header's bottom edge so the
    // list sits flush under the bar and the hover path has no gap.
    const header = item.closest('[data-site-header]');
    if (header) {
      const gap = header.getBoundingClientRect().bottom - item.getBoundingClientRect().bottom;
      panel.style.setProperty('--nav-dropdown-offset', Math.max(0, Math.round(gap)) + 'px');
    }
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    item.dataset.openedBy = openedBy;
    item._navOpenedAt = performance.now();
    openNavItem = item;
  };

  const bindNavDropdown = (item) => {
    const { toggle, panel } = navParts(item);
    if (!toggle || !panel || item._navBound) return;
    item._navBound = true;

    item.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(item._navTimer);
      if (item.classList.contains('is-open')) return;
      // Moving straight from one open item to the next switches instantly.
      const delay = openNavItem ? 0 : HOVER_OPEN_DELAY;
      item._navTimer = setTimeout(() => openNavDropdown(item, 'hover'), delay);
    });

    item.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(item._navTimer);
      if (item.dataset.openedBy !== 'hover') return;
      item._navTimer = setTimeout(() => closeNavDropdown(item), HOVER_CLOSE_DELAY);
    });

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = item.classList.contains('is-open');
      const openClick = isOpen && item.dataset.openedBy === 'hover' && e.detail > 0 &&
        performance.now() - (item._navOpenedAt || 0) < HOVER_CLICK_GRACE;
      if (openClick) item.dataset.openedBy = 'click';
      else if (isOpen) closeNavDropdown(item);
      else openNavDropdown(item, 'click');
    });

    toggle.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault();
      openNavDropdown(item, 'click');
      const first = panel.querySelector('a');
      if (first) first.focus();
    });

    // Tabbing out of the item (label, chevron, panel links) closes it.
    item.addEventListener('focusout', (e) => {
      if (!item.classList.contains('is-open')) return;
      if (e.relatedTarget && !item.contains(e.relatedTarget)) closeNavDropdown(item);
    });
  };

  const bindNavDropdowns = (root) => {
    root.querySelectorAll('[data-nav-dropdown]').forEach(bindNavDropdown);
  };
  bindNavDropdowns(document);

  document.addEventListener('click', (e) => {
    if (openNavItem && !openNavItem.contains(e.target)) closeNavDropdown(openNavItem);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !openNavItem) return;
    const item = openNavItem;
    closeNavDropdown(item, item.contains(document.activeElement));
  });

  // The desktop nav is hidden below 990px: don't keep a panel open there
  // (or bring it back open when the window is widened again).
  const onNavBreakpoint = (e) => {
    if (!e.matches && openNavItem) closeNavDropdown(openNavItem);
  };
  if (navDesktopQuery.addEventListener) navDesktopQuery.addEventListener('change', onNavBreakpoint);
  else if (navDesktopQuery.addListener) navDesktopQuery.addListener(onNavBreakpoint);

  // Back/forward cache: don't restore a page with a panel left open.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted && openNavItem) closeNavDropdown(openNavItem);
  });

  // Theme editor: the header section is re-rendered in place, so bind the
  // new items (the old ones, and any open state, are gone with the old DOM).
  document.addEventListener('shopify:section:load', (e) => {
    if (openNavItem && !document.contains(openNavItem)) openNavItem = null;
    bindNavDropdowns(e.target);
  });

  // ---- Mobile drawer groups ----
  // Expandable menu items with child links (snippets/mobile-menu.liquid).
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-drawer-group-toggle]');
    if (!toggle) return;
    const list = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!list) return;
    const expand = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expand));
    list.hidden = !expand;
  });

  // ---- Hero video: force autoplay where browsers block it ----
  // Some browsers/devices silently refuse autoplay even when muted.
  // Re-assert the attributes via JS and call play() explicitly.
  document.querySelectorAll('.hero__video, .collection-grid__tile-video').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('muted', '');

    const tryPlay = () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {
          // Last-ditch: retry once on the first user interaction
          const retry = () => {
            video.play().catch(() => {});
            window.removeEventListener('touchstart', retry);
            window.removeEventListener('click', retry);
          };
          window.addEventListener('touchstart', retry, { once: true });
          window.addEventListener('click', retry, { once: true });
        });
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
      video.addEventListener('canplay', tryPlay, { once: true });
    }
  });

  // ---- Generic horizontal carousel: scroll-progress slider + drag ----
  // Attaches to any scope containing matched data-carousel-viewport,
  // data-carousel-slider, and data-carousel-thumb elements (used by the
  // product carousel and the social proof section).
  // keepSpace: hide the slider with visibility instead of display when
  // nothing overflows, so switching panes doesn't move the page below.
  function attachCarouselSlider(scope, { keepSpace = false } = {}) {
    const viewport = scope.querySelector('[data-carousel-viewport]');
    const slider = scope.querySelector('[data-carousel-slider]');
    const thumb = scope.querySelector('[data-carousel-thumb]');
    if (!viewport || !slider || !thumb) return null;
    // Thumb is the only child of the track
    const track = thumb.parentElement;
    if (!track) return null;

    const updateThumb = () => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 0) {
        if (keepSpace) slider.style.visibility = 'hidden';
        else slider.style.display = 'none';
        return;
      }
      slider.style.display = '';
      slider.style.visibility = '';
      const ratio = viewport.clientWidth / viewport.scrollWidth;
      const widthPct = Math.max(ratio * 100, 8);
      const progress = viewport.scrollLeft / max;
      const leftPct = progress * (100 - widthPct);
      thumb.style.width = widthPct + '%';
      thumb.style.left = leftPct + '%';
    };

    updateThumb();
    viewport.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateThumb).observe(viewport);
    }

    // Drag-to-scroll on the track
    let dragging = false;
    const seekFromEvent = (clientX) => {
      const rect = track.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      const max = viewport.scrollWidth - viewport.clientWidth;
      viewport.scrollLeft = ratio * max;
    };

    const onPointerDown = (e) => {
      dragging = true;
      thumb.setAttribute('data-dragging', 'true');
      seekFromEvent(e.clientX);
      track.setPointerCapture && track.setPointerCapture(e.pointerId);
    };
    const onPointerMove = (e) => {
      if (!dragging) return;
      seekFromEvent(e.clientX);
    };
    const onPointerUp = () => {
      dragging = false;
      thumb.removeAttribute('data-dragging');
    };

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);

    return updateThumb;
  }

  // ---- Product carousel: gender tabs + All / Sneakers / Boots filter ----
  // Each tab panel holds one pane per category (data-carousel-pane), each
  // with its own scroller and slider. The filter applies on top of the
  // active tab; a filter button is hidden when the active tab has no pane
  // for it, and changing either control starts the pane at the beginning.
  function initProductCarousel(carousel) {
    if (carousel.dataset.carouselBound) return;
    carousel.dataset.carouselBound = 'true';

    const tabs = Array.from(carousel.querySelectorAll('[role="tab"]'));
    const panels = Array.from(carousel.querySelectorAll('[role="tabpanel"]'));
    const filters = Array.from(carousel.querySelectorAll('[data-category-filter]'));
    const updaters = new Map();
    carousel.querySelectorAll('[data-carousel-pane]').forEach((pane) => {
      updaters.set(pane, attachCarouselSlider(pane, { keepSpace: true }));
    });
    let category = 'all';

    const showCategory = (panel, wanted) => {
      if (!panel) return;
      const panes = Array.from(panel.querySelectorAll('[data-carousel-pane]'));
      const available = panes.map((pane) => pane.dataset.carouselPane);
      category = available.includes(wanted) ? wanted : 'all';
      panes.forEach((pane) => {
        const on = pane.dataset.carouselPane === category;
        pane.hidden = !on;
        if (!on) return;
        const viewport = pane.querySelector('[data-carousel-viewport]');
        if (viewport) viewport.scrollLeft = 0;
        const update = updaters.get(pane);
        if (update) update();
      });
      filters.forEach((button) => {
        const value = button.dataset.categoryFilter;
        button.hidden = value !== 'all' && !available.includes(value);
        button.setAttribute('aria-pressed', value === category ? 'true' : 'false');
      });
    };

    const activate = (targetId) => {
      let active = null;
      tabs.forEach((tab) => {
        const selected = tab.getAttribute('data-tab-target') === targetId;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        const isTarget = panel.id === targetId;
        panel.hidden = !isTarget;
        if (isTarget) active = panel;
      });
      showCategory(active, category);
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activate(tab.getAttribute('data-tab-target'));
      });
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const i = tabs.indexOf(tab);
        const next =
          e.key === 'ArrowRight'
            ? tabs[(i + 1) % tabs.length]
            : tabs[(i - 1 + tabs.length) % tabs.length];
        next.focus();
        activate(next.getAttribute('data-tab-target'));
      });
    });

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        showCategory(panels.find((panel) => !panel.hidden) || panels[0], button.dataset.categoryFilter);
      });
    });

    showCategory(panels.find((panel) => !panel.hidden) || panels[0], 'all');
  }

  document.querySelectorAll('[data-product-carousel]').forEach(initProductCarousel);

  // ---- Boot lineup: color swatches swap the card's image, name and links ----
  function initBootLineup(root) {
    root.querySelectorAll('[data-lineup-card]').forEach((card) => {
      if (card.dataset.lineupBound) return;
      card.dataset.lineupBound = 'true';

      const swatches = Array.from(card.querySelectorAll('[data-lineup-swatch]'));
      if (!swatches.length) return;
      const images = Array.from(card.querySelectorAll('[data-lineup-image]'));
      const colorName = card.querySelector('[data-lineup-color-name]');
      const links = Array.from(card.querySelectorAll('[data-lineup-link]'));

      // Load the other colors' images before the card is on screen, so a
      // swatch tap swaps instantly (hidden lazy images never load by
      // themselves).
      const warm = () => images.forEach((img) => { img.loading = 'eager'; });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            warm();
            observer.disconnect();
          }
        }, { rootMargin: '600px 0px' });
        observer.observe(card);
      }
      card.addEventListener('pointerenter', warm, { once: true });
      card.addEventListener('focusin', warm, { once: true });

      const select = (swatch, moveFocus) => {
        const color = swatch.dataset.color;
        swatches.forEach((s) => {
          const on = s === swatch;
          s.setAttribute('aria-checked', on ? 'true' : 'false');
          s.tabIndex = on ? 0 : -1;
        });
        images.forEach((img) => { img.hidden = img.dataset.lineupImage !== color; });
        if (colorName) colorName.textContent = color;
        links.forEach((link) => { link.href = swatch.dataset.url; });
        if (moveFocus) swatch.focus();
      };

      swatches.forEach((swatch, i) => {
        swatch.addEventListener('click', () => select(swatch, false));
        swatch.addEventListener('keydown', (e) => {
          const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
          if (!step) return;
          e.preventDefault();
          select(swatches[(i + step + swatches.length) % swatches.length], true);
        });
      });
    });
  }

  initBootLineup(document);

  // Theme editor: re-bind sections that are re-rendered after an edit.
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-product-carousel]').forEach(initProductCarousel);
    initBootLineup(e.target);
  });

  // ---- Social proof: same slider behaviour, no tabs ----
  document.querySelectorAll('[data-social-proof]').forEach((sp) => {
    attachCarouselSlider(sp);
  });

  // ---- FAQ: toggle aria-expanded; CSS handles the height animation ----
  document.querySelectorAll('[data-faq-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  // ---- Collection grid: filter sidebar toggle, sort auto-submit ----
  document.querySelectorAll('[data-collection-grid]').forEach((grid) => {
    const toggle = grid.querySelector('[data-filters-toggle]');
    const panel = grid.querySelector('[data-filters-panel]');

    if (toggle && panel) {
      // On desktop the panel is always visible; on mobile it's hidden until
      // the user taps Filters. Use aria-hidden so CSS can decide.
      const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

      const apply = (open) => {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (isDesktop()) {
          panel.removeAttribute('aria-hidden');
        } else {
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
      };

      apply(false);
      window.addEventListener('resize', () => apply(toggle.getAttribute('aria-expanded') === 'true'));

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        apply(!expanded);
      });
    }

    // Sort dropdown: navigate to ?sort_by=... preserving current filters
    const sortSelect = grid.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Filter checkboxes / price range: submit the form so URL params update
    const filterForm = grid.querySelector('[data-filter-form]');
    if (filterForm) {
      // Preserve the current sort_by in the hidden input
      const sortBy = new URL(window.location.href).searchParams.get('sort_by');
      const sortInput = filterForm.querySelector('input[name="sort_by"]');
      if (sortInput && sortBy) sortInput.value = sortBy;

      filterForm.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"], input[type="number"]')) {
          // Debounce price range slightly so users can finish typing
          if (e.target.type === 'number') {
            clearTimeout(filterForm._priceTimer);
            filterForm._priceTimer = setTimeout(() => filterForm.submit(), 600);
          } else {
            filterForm.submit();
          }
        }
      });
    }
  });

  // ---- Activities: swap the media image when an activity is hovered ----
  document.querySelectorAll('[data-activities]').forEach((section) => {
    const image = section.querySelector('[data-activities-image]');
    const items = section.querySelectorAll('[data-activity-item]');
    if (!image || !items.length) return;

    // Pre-warm each activity's image so the swap is instant
    items.forEach((item) => {
      const url = item.getAttribute('data-activity-image');
      if (url) {
        const i = new Image();
        i.src = url;
      }
    });

    const activate = (item) => {
      const url = item.getAttribute('data-activity-image');
      const alt = item.getAttribute('data-activity-alt') || '';
      if (!url || image.getAttribute('src') === url) {
        // Still update the active class even if url unchanged
        items.forEach((other) => {
          const isActive = other === item;
          other.classList.toggle('is-active', isActive);
          if (other.tagName === 'BUTTON') {
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }
        });
        return;
      }

      image.setAttribute('data-fading', 'true');
      // Wait for the fade-out before swapping src so the change is smooth
      const onFade = () => {
        image.removeEventListener('transitionend', onFade);
        image.src = url;
        if (alt) image.alt = alt;
        // Force a reflow then fade back in
        void image.offsetWidth;
        image.removeAttribute('data-fading');
      };
      image.addEventListener('transitionend', onFade);
      // Safety: if transitionend doesn't fire, swap after a short delay
      setTimeout(() => {
        if (image.getAttribute('data-fading') === 'true') {
          image.removeEventListener('transitionend', onFade);
          image.src = url;
          if (alt) image.alt = alt;
          image.removeAttribute('data-fading');
        }
      }, 320);

      items.forEach((other) => {
        const isActive = other === item;
        other.classList.toggle('is-active', isActive);
        if (other.tagName === 'BUTTON') {
          other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    };

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => activate(item));
      item.addEventListener('focus', () => activate(item));
    });
  });

  // Variant selection on product page
  const productSection = document.querySelector('[data-product-section]');
  if (productSection) {
    const productJsonEl = productSection.querySelector('[data-product-json]');
    let productData = null;
    try {
      productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    } catch (_) {
      productData = null;
    }

    const variantInput = productSection.querySelector('[data-variant-id-input]');
    const submitButton = productSection.querySelector('[data-add-to-cart]');
    const submitText = productSection.querySelector('[data-add-to-cart-text]');
    const priceContainer = productSection.querySelector('[data-product-price]');

    function getSelectedOptions() {
      // Returns {name, value} pairs for each rendered + checked option input.
      // The radio's `name` attribute is `options[OptionName]`; we parse the
      // option name out so we can match against productData.options by name
      // (not by array position), which keeps us robust to products with
      // extra option dimensions we don't render a picker for (e.g.
      // "Target gender" alongside Color and Size).
      const inputs = productSection.querySelectorAll('[data-option-input]:checked');
      return Array.from(inputs).map((input) => {
        const m = input.name && input.name.match(/^options\[(.+)\]$/);
        return { name: m ? m[1] : null, value: input.value };
      });
    }

    function findVariant(selected) {
      if (!productData) return null;
      const optionNames = productData.options || [];
      return productData.variants.find((variant) =>
        selected.every(({ name, value }) => {
          if (!name) return false;
          const idx = optionNames.indexOf(name);
          if (idx < 0) return false;
          return variant.options[idx] === value;
        })
      );
    }

    const selectedColorEl = productSection.querySelector('[data-selected-color]');
    const sizeTriggerText = productSection.querySelector('[data-size-trigger-text]');
    // Queried from the document rather than the section: the sticky footer is
    // teleported to <body> further down, so it may not be a section
    // descendant by the time this runs.
    const stickySizeText = document.querySelector('[data-sticky-size-text]');
    const addToCartText = (submitButton && submitButton.dataset.defaultText) || 'Add to cart';

    function updateLabels() {
      const colorInput = productSection.querySelector('[data-option-color-value]:checked');
      const sizeInput = productSection.querySelector('[data-option-size-value]:checked');
      if (selectedColorEl) selectedColorEl.textContent = colorInput ? colorInput.value : '';
      // The in-page trigger and the sticky footer's size box show the same
      // label, so they stay in sync from one place.
      const sizeLabel = sizeInput ? sizeInput.value : 'Select Size';
      if (sizeTriggerText) sizeTriggerText.textContent = sizeLabel;
      if (stickySizeText) stickySizeText.textContent = sizeLabel;
    }

    function filterGalleryByColor() {
      const items = productSection.querySelectorAll('.product-page__gallery-item');
      if (!items.length) return;

      const colorInput = productSection.querySelector('[data-option-color-value]:checked');
      const selected = colorInput
        ? colorInput.value.trim().toLowerCase().replace(/\s+/g, '-')
        : '';

      let visibleCount = 0;
      items.forEach((item) => {
        const tag = item.getAttribute('data-variant-color');
        const matches = !tag || tag === selected;
        item.classList.toggle('variant-image-hidden', !matches);
        if (matches) visibleCount++;
      });

      if (visibleCount === 0) {
        items.forEach((item) => item.classList.remove('variant-image-hidden'));
      }
    }

    // Feature cards live in a separate section (outside [data-product-section]),
    // so query at document scope.
    function filterFeatureCardsByColor() {
      const items = document.querySelectorAll('.product-features__item[data-variant-color]');
      if (!items.length) return;

      const colorInput = productSection.querySelector('[data-option-color-value]:checked');
      const selected = colorInput
        ? colorInput.value.trim().toLowerCase().replace(/\s+/g, '-')
        : '';

      let visibleCount = 0;
      items.forEach((item) => {
        const tag = item.getAttribute('data-variant-color');
        const matches = tag === selected;
        item.classList.toggle('variant-image-hidden', !matches);
        if (matches) visibleCount++;
      });

      if (visibleCount === 0) {
        items.forEach((item) => item.classList.remove('variant-image-hidden'));
      }
    }

    // Live size availability — recompute which sizes are in stock for the
    // currently selected color and reflect it on the dropdown radios, the
    // mobile size sheet, and the zoom bar buttons.
    function updateSizeAvailability() {
      if (!productData) return;
      const optionNames = productData.options || [];
      let colorIdx = -1;
      let sizeIdx = -1;
      optionNames.forEach((n, i) => {
        const norm = (n || '').toLowerCase();
        if (norm === 'color' || norm === 'colour') colorIdx = i;
        else if (norm === 'size') sizeIdx = i;
      });
      if (sizeIdx < 0) return;

      const colorInput = productSection.querySelector('[data-option-color-value]:checked');
      const selectedColor = colorInput ? colorInput.value : null;

      // Build a size -> available map for the selected color (OR across variants).
      const avail = {};
      productData.variants.forEach((v) => {
        if (colorIdx >= 0 && selectedColor != null && v.options[colorIdx] !== selectedColor) return;
        const sizeVal = v.options[sizeIdx];
        if (v.available) avail[sizeVal] = true;
        else if (!(sizeVal in avail)) avail[sizeVal] = false;
      });
      const isAvail = (val) => avail[val] === true;

      // Dropdown radios + labels.
      productSection.querySelectorAll('[data-option-size-value]').forEach((input) => {
        const ok = isAvail(input.value);
        input.disabled = !ok;
        const label = input.id
          ? productSection.querySelector(
              'label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]'
            )
          : null;
        if (label) label.classList.toggle('is-unavailable', !ok);
      });

      // Mobile size sheet buttons.
      document.querySelectorAll('[data-size-pick]').forEach((btn) => {
        const ok = isAvail(btn.dataset.sizePick);
        btn.disabled = !ok;
        btn.classList.toggle('is-unavailable', !ok);
        if (ok) btn.removeAttribute('aria-disabled');
        else btn.setAttribute('aria-disabled', 'true');
      });

      // Zoom bar buttons.
      document.querySelectorAll('[data-zoom-size]').forEach((btn) => {
        const ok = isAvail(btn.dataset.zoomSize);
        btn.disabled = !ok;
        btn.classList.toggle('is-unavailable', !ok);
      });
    }

    function updateVariant() {
      updateLabels();
      filterGalleryByColor();
      filterFeatureCardsByColor();
      updateSizeAvailability();

      const selected = getSelectedOptions();
      const sizeNeeded = !!productSection.querySelector('[data-option-size-value]');
      const sizeChosen = !!productSection.querySelector('[data-option-size-value]:checked');

      // Until the shopper picks a size the CTA still reads "Add to cart" and
      // stays clickable — clicking it opens the size dropdown rather than
      // submitting. data-needs-size is the flag the click and submit guards
      // read; it is the single signal for "no size yet", so nothing has to
      // infer that state from the button's label or disabled attribute.
      if (sizeNeeded && !sizeChosen) {
        if (submitButton) {
          submitButton.dataset.needsSize = 'true';
          submitButton.disabled = false;
          if (submitText) submitText.textContent = addToCartText.toUpperCase();
        }
        return;
      }

      const variant = findVariant(selected);
      if (submitButton) submitButton.dataset.needsSize = 'false';

      if (!variant) {
        if (submitButton) {
          submitButton.disabled = true;
          if (submitText) submitText.textContent = 'UNAVAILABLE';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (submitButton) {
        submitButton.disabled = !variant.available;
        if (submitText) {
          submitText.textContent = (variant.available ? addToCartText : 'Sold out').toUpperCase();
        }
      }

      if (priceContainer) {
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        });
        const price = formatter.format(variant.price / 100);
        const compare =
          variant.compare_at_price && variant.compare_at_price > variant.price
            ? formatter.format(variant.compare_at_price / 100)
            : null;

        priceContainer.innerHTML = compare
          ? `<span class="price"><span class="price__sale">${price}</span><span class="price__compare"><s>${compare}</s></span></span>`
          : `<span class="price"><span>${price}</span></span>`;
      }
    }

    productSection.querySelectorAll('[data-option-input]').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    updateLabels();
    filterGalleryByColor();
    filterFeatureCardsByColor();
    updateSizeAvailability();

    // Back/forward: the browser restores the colour and size radios after this script has run (a reload from
    // history, or a bfcache restore), which left the label, gallery, feature cards, sizes, price and the variant id
    // on the server's colour while a different swatch was checked. pageshow fires after that restore on every load.
    window.addEventListener('pageshow', updateVariant);

    // Size dropdown — open/close + close on outside click + close on selection
    const sizeDropdown = productSection.querySelector('[data-size-dropdown]');
    const sizeTrigger = productSection.querySelector('[data-size-trigger]');
    const sizeList = productSection.querySelector('[data-size-list]');
    if (sizeDropdown && sizeTrigger && sizeList) {
      const setOpen = (open) => {
        sizeTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          sizeList.removeAttribute('hidden');
        } else {
          sizeList.setAttribute('hidden', '');
        }
      };

      sizeTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = sizeTrigger.getAttribute('aria-expanded') === 'true';
        setOpen(!isOpen);
      });

      // Add to cart with no size chosen opens this dropdown instead of
      // submitting — same on desktop and mobile. stopPropagation keeps the
      // outside-click handler below from closing it again on the same click,
      // and setOpen(true) is used rather than a toggle so a second press
      // can't close it.
      if (submitButton) {
        submitButton.addEventListener('click', (e) => {
          if (submitButton.dataset.needsSize !== 'true') return;
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
          sizeTrigger.focus();
        });
      }

      sizeList.addEventListener('change', () => setOpen(false));

      document.addEventListener('click', (e) => {
        if (!sizeDropdown.contains(e.target)) setOpen(false);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') setOpen(false);
      });
    }

    // Description ...more toggle
    const descToggle = productSection.querySelector('[data-description-toggle]');
    const descWrap = productSection.querySelector('[data-description-wrap]');
    const descToggleText = productSection.querySelector('[data-description-toggle-text]');
    if (descToggle && descWrap) {
      descToggle.addEventListener('click', () => {
        const expanded = descWrap.dataset.expanded === 'true';
        descWrap.dataset.expanded = expanded ? 'false' : 'true';
        descToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (descToggleText) descToggleText.textContent = expanded ? '...more' : 'less';
      });
    }

    // Mobile sticky CTA + size picker bottom sheet
    // Teleport the sticky CTA + size sheet to be DIRECT children of <body>.
    // They render inside the Shopify section wrapper (<div class=
    // "shopify-section">), and on WebKit browsers that wrapper has been
    // observed to act as a containing block for our position: fixed
    // elements, sizing them to the wrapper's width instead of the
    // viewport. Reparenting them under <body> removes all interference.
    const stickyCta = document.querySelector('[data-sticky-cta]');
    const sizeSheet = document.querySelector('[data-size-sheet]');
    if (stickyCta && stickyCta.parentNode !== document.body) {
      document.body.appendChild(stickyCta);
    }
    if (sizeSheet && sizeSheet.parentNode !== document.body) {
      document.body.appendChild(sizeSheet);
    }

    const sizeSheetOpeners = document.querySelectorAll('[data-size-sheet-open]');
    const sizeSheetClosers = document.querySelectorAll('[data-size-sheet-close]');
    const sizeSheetOptions = document.querySelectorAll('[data-size-pick]');
    const productForm = productSection.querySelector('#product-form');

    // Publish the footer's height so .pdp-zoom-exit can clear it during
    // full-screen zoom instead of hardcoding a guess. Observed because the
    // height shifts with the safe-area inset and webfont loading.
    if (stickyCta) {
      const setStickyCtaHeight = () => {
        const h = stickyCta.offsetHeight;
        if (h) document.documentElement.style.setProperty('--pdp-sticky-cta-height', h + 'px');
      };
      setStickyCtaHeight();
      if ('ResizeObserver' in window) {
        new ResizeObserver(setStickyCtaHeight).observe(stickyCta);
      }
    }

    // Sticky footer Add to Cart. Mirrors the main submit's disabled state and
    // submits the same form, so variant resolution stays in one place.
    const stickyAdd = document.querySelector('[data-sticky-add]');
    const stickyAddText = document.querySelector('[data-sticky-add-text]');
    const mainSubmit = productSection.querySelector('[data-add-to-cart]');
    const mainSubmitText = productSection.querySelector('[data-add-to-cart-text]');

    if (stickyAdd && mainSubmit) {
      const stickySizeBtn = document.querySelector('[data-sticky-size]');

      // True while the CTA is only waiting on a size, as opposed to the
      // variant being genuinely sold out or unavailable. Read from the flag
      // the main button carries rather than from its label, which now reads
      // "Add to cart" in this state like every other.
      const awaitingSize = () => mainSubmit.dataset.needsSize === 'true';

      const syncStickyAdd = () => {
        // Stays tappable while a size is still needed so it can open the size
        // sheet. Only a sold-out or unavailable variant actually disables it.
        stickyAdd.disabled = mainSubmit.disabled && !awaitingSize();
        // The main button is the source of truth for the label, including its
        // Sold out and Unavailable states.
        if (stickyAddText && mainSubmitText) {
          stickyAddText.textContent = (mainSubmitText.textContent || '').trim();
        }
      };

      new MutationObserver(syncStickyAdd).observe(mainSubmit, {
        attributes: true,
        attributeFilter: ['disabled', 'data-needs-size'],
      });
      if (mainSubmitText) {
        new MutationObserver(syncStickyAdd).observe(mainSubmitText, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
      syncStickyAdd();

      stickyAdd.addEventListener('click', () => {
        if (stickyAdd.disabled) return;
        // No size chosen yet: hand off to the size box, which already owns
        // opening the sheet, rather than submitting a form that can't resolve
        // a variant. Keyed on the flag, not on mainSubmit.disabled, which is
        // no longer set in this state.
        if (awaitingSize()) {
          if (stickySizeBtn) stickySizeBtn.click();
          return;
        }
        if (!productForm) return;
        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit(mainSubmit);
        } else {
          mainSubmit.click();
        }
      });
    }

    if (sizeSheet) {
      const setSheetOpen = (open) => {
        if (open) {
          sizeSheet.removeAttribute('hidden');
          sizeSheet.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(() => sizeSheet.classList.add('is-open'));
          // clip, not hidden: hidden makes body a scroll container and unpins the sticky header.
          document.body.style.overflow = CSS.supports('overflow', 'clip') ? 'clip' : 'hidden';
        } else {
          sizeSheet.classList.remove('is-open');
          sizeSheet.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          setTimeout(() => sizeSheet.setAttribute('hidden', ''), 300);
        }
      };

      sizeSheetOpeners.forEach((btn) => btn.addEventListener('click', () => setSheetOpen(true)));
      sizeSheetClosers.forEach((btn) => btn.addEventListener('click', () => setSheetOpen(false)));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sizeSheet.classList.contains('is-open')) {
          setSheetOpen(false);
        }
      });

      // Picking a size in the sheet selects it and closes the sheet — it does
      // not add to cart. The sticky footer's Add to Cart button is the commit
      // step now that the size prompt and the CTA are separate controls.
      // Checking the radio fires the existing variant-update flow, which
      // relabels the size box and enables the button.
      sizeSheetOptions.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          const value = btn.dataset.sizePick;
          const radio = productSection.querySelector(`[data-option-size-value="${CSS.escape(value)}"]`);
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          setSheetOpen(false);
        });
      });
    }
  }

  // Cart quantity steppers
  document.querySelectorAll('[data-cart-line]').forEach((line) => {
    const input = line.querySelector('[data-quantity-input]');
    const dec = line.querySelector('[data-quantity-decrease]');
    const inc = line.querySelector('[data-quantity-increase]');

    if (!input) return;

    if (dec) {
      dec.addEventListener('click', () => {
        input.value = Math.max(0, parseInt(input.value, 10) - 1);
        input.form && input.form.submit();
      });
    }
    if (inc) {
      inc.addEventListener('click', () => {
        input.value = parseInt(input.value, 10) + 1;
        input.form && input.form.submit();
      });
    }
  });

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    document
      .querySelectorAll('.featured-collection, .image-with-text, .collection-list, .rich-text')
      .forEach((el) => observer.observe(el));

    // Autoplay product gallery videos when they scroll into view, pause
    // when out of view. Browsers will silently skip autoplay for videos
    // that aren't visible on initial load (especially below the fold)
    // even when muted, so we drive playback manually.
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {
                /* autoplay blocked — leave paused, controls let user start */
              });
            }
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    document.querySelectorAll('.product-page__video').forEach((video) => {
      videoObserver.observe(video);
    });
  }

  // ---- PDP full-screen image zoom ----
  // Clicking a product image expands the gallery into a full-bleed vertical
  // stack of large images below the nav bar; the page scrolls through them.
  // Clicking any image again (or the exit button / Escape) collapses back.
  const productPage = document.querySelector('[data-product-section]');
  const zoomExit = document.querySelector('[data-pdp-zoom-exit]');
  if (productPage && zoomExit) {
    if (zoomExit.parentNode !== document.body) {
      document.body.appendChild(zoomExit);
    }

    const siteHeader = document.querySelector('[data-site-header]');
    let zoomed = false;

    function galleryImageButtons() {
      return Array.from(
        productPage.querySelectorAll(
          '.product-page__gallery-item:not(.variant-image-hidden) [data-pdp-image-trigger]'
        )
      );
    }

    function setZoomOffset() {
      const h = siteHeader ? siteHeader.offsetHeight : 0;
      document.documentElement.style.setProperty('--pdp-zoom-offset', (h || 90) + 'px');
    }

    // ---- Bottom add-to-cart bar (visible only while zoomed) ----
    const zoomBar = document.querySelector('[data-pdp-zoom-bar]');
    if (zoomBar) {
      if (zoomBar.parentNode !== document.body) document.body.appendChild(zoomBar);

      const zoomSizesWrap = zoomBar.querySelector('[data-zoom-sizes]');
      const zoomAdd = zoomBar.querySelector('[data-zoom-add]');
      const zoomAddText = zoomBar.querySelector('[data-zoom-add-text]');
      const mainSubmit = productPage.querySelector('[data-add-to-cart]');
      const mainSubmitText = productPage.querySelector('[data-add-to-cart-text]');
      const productFormEl = productPage.querySelector('#product-form');
      const sizeRadios = Array.from(productPage.querySelectorAll('[data-option-size-value]'));

      // Build a size button per real size radio, mirroring availability.
      sizeRadios.forEach((radio) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-zoom-bar__size';
        btn.textContent = radio.value;
        btn.dataset.zoomSize = radio.value;
        if (radio.disabled) {
          btn.disabled = true;
          btn.classList.add('is-unavailable');
        }
        btn.addEventListener('click', () => {
          if (radio.disabled) return;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          syncActiveSize();
        });
        zoomSizesWrap.appendChild(btn);
      });

      function syncActiveSize() {
        const checked = productPage.querySelector('[data-option-size-value]:checked');
        const val = checked ? checked.value : null;
        zoomSizesWrap.querySelectorAll('.pdp-zoom-bar__size').forEach((b) => {
          b.classList.toggle('is-active', b.dataset.zoomSize === val);
        });
      }

      function syncAddButton() {
        if (!mainSubmit) return;
        // Unlike the in-page CTA and the sticky footer, this bar shows its own
        // size strip inline, so there is no picker to open: stay disabled
        // until a size is chosen rather than presenting an enabled button that
        // the form's needs-size guard would silently swallow.
        zoomAdd.disabled = mainSubmit.disabled || mainSubmit.dataset.needsSize === 'true';
        if (zoomAddText && mainSubmitText) zoomAddText.textContent = mainSubmitText.textContent;
      }

      // Mirror the main CTA's disabled state + label as the shopper picks.
      // data-needs-size has to be watched too: picking a size for an available
      // variant flips only that flag — the label stays "Add to cart" and
      // disabled stays false — so without it this button would never re-enable.
      if (mainSubmit) {
        new MutationObserver(syncAddButton).observe(mainSubmit, {
          attributes: true,
          attributeFilter: ['disabled', 'data-needs-size'],
        });
      }
      if (mainSubmitText) {
        new MutationObserver(syncAddButton).observe(mainSubmitText, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
      syncAddButton();
      syncActiveSize();

      zoomAdd.addEventListener('click', () => {
        if (zoomAdd.disabled || !productFormEl || !mainSubmit) return;
        if (typeof productFormEl.requestSubmit === 'function') {
          productFormEl.requestSubmit(mainSubmit);
        } else {
          mainSubmit.click();
        }
      });

      productPage.addEventListener('change', (e) => {
        if (e.target.closest('[data-option-size-value]')) syncActiveSize();
      });

      // Expose show/hide for enter/exit zoom.
      zoomBar._show = () => { zoomBar.hidden = false; };
      zoomBar._hide = () => { zoomBar.hidden = true; };
    }

    function enterZoom(clickedBtn) {
      zoomed = true;
      setZoomOffset();
      document.body.classList.add('is-pdp-zoomed');
      zoomExit.hidden = false;
      if (zoomBar && zoomBar._show) zoomBar._show();

      // Swap each image to its high-res source so it stays crisp full screen.
      galleryImageButtons().forEach((btn) => {
        const img = btn.querySelector('img');
        if (img && btn.dataset.pdpImageFull && !img.dataset.thumbSrc) {
          img.dataset.thumbSrc = img.getAttribute('src') || '';
          img.dataset.thumbSrcset = img.getAttribute('srcset') || '';
          img.removeAttribute('srcset');
          img.src = btn.dataset.pdpImageFull;
        }
      });

      // Bring the clicked image to the top, just under the nav.
      const item = clickedBtn && clickedBtn.closest('.product-page__gallery-item');
      if (item) {
        requestAnimationFrame(() => item.scrollIntoView({ block: 'start' }));
      }
    }

    function exitZoom() {
      zoomed = false;
      document.body.classList.remove('is-pdp-zoomed');
      zoomExit.hidden = true;
      if (zoomBar && zoomBar._hide) zoomBar._hide();

      // Restore the original responsive thumbnails.
      galleryImageButtons().forEach((btn) => {
        const img = btn.querySelector('img');
        if (img && img.dataset.thumbSrc !== undefined) {
          if (img.dataset.thumbSrc) img.src = img.dataset.thumbSrc;
          if (img.dataset.thumbSrcset) img.setAttribute('srcset', img.dataset.thumbSrcset);
          delete img.dataset.thumbSrc;
          delete img.dataset.thumbSrcset;
        }
      });

      // The tall zoom stack leaves the page scrolled far down; return the
      // shopper to the top of the normal PDP.
      window.scrollTo(0, 0);
    }

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pdp-image-trigger]');
      if (!btn) return;
      e.preventDefault();
      if (zoomed) exitZoom();
      else enterZoom(btn);
    });

    zoomExit.addEventListener('click', exitZoom);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && zoomed) exitZoom();
    });

    window.addEventListener('resize', () => {
      if (zoomed) setZoomOffset();
    });
  }

  // Public API for landing-page sections (assets/lp.js).
  // addToCart keeps Shopify's error body: on a 422 it rejects with an Error whose
  // `description` is the shopper-facing text (postJSON above discards it).
  window.UovoTheme = Object.assign(window.UovoTheme || {}, {
    openDrawer: openDrawerByName,
    closeDrawer: closeDrawer,
    refreshCartDrawer: refreshCartDrawerFromSection,
    // properties (optional): line-item properties, e.g. { _lp: 'lp-nurses-a' }; sent only when non-empty.
    addToCart: async function (variantId, quantity, properties) {
      const item = { id: Number(variantId), quantity: Number(quantity) || 1 };
      if (properties && typeof properties === 'object' && !Array.isArray(properties) && Object.keys(properties).length) item.properties = properties;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [item],
          sections: 'cart-drawer',
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const err = new Error(data.description || data.message || 'Cart request failed: ' + res.status);
        err.status = res.status;
        err.description = data.description || '';
        throw err;
      }
      if (data.sections && data.sections['cart-drawer']) refreshCartDrawerFromSection(data.sections['cart-drawer']);
      openDrawerByName('cart');
      return data;
    },
  });
})();
